"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _characteristicsList = _interopRequireDefault(require("@/components/characteristicsList.vue"));
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "SptIndex",
  components: {
    characteristicsList: _characteristicsList.default
  },
  computed: {
    num: function num() {
      return String(this.$route.query.num || 1);
    },
    courseName: function courseName() {
      return this.$route.query.courseName || "";
    },
    bannerImageClass: function bannerImageClass() {
      if (this.num === "1") return "img1";
      if (this.num === "2") return "img2";
      if (this.num === "3") return "img3";
      if (this.num === "4") return "img4";
      return "img5";
    },
    bannerTextClass: function bannerTextClass() {
      if (this.num === "1") return "nav1";
      if (this.num === "2") return "nav2";
      if (this.num === "3") return "nav3";
      if (this.num === "4") return "nav4";
      if (this.num === "5") return "nav5";
      return "nav6";
    }
  }
};